/* eslint-disable react/jsx-no-useless-fragment */
import { Link } from 'gatsby';
import React from 'react';
import { ContentType, SlugPrefix } from '@models/pages';
import { defaultLocale } from '@services';

function LinkChd({
  children, link, linkStyles, linkTitle, href, wrap = false,
} :any) {
  const includesChdDomain = (url : string) => url.includes('childrenshealthdefense.org');
  if (href) {
    return (
      <>
        {(includesChdDomain(href) || href[0] === '/')
          ? (
            <a
              href={href}
              className={linkStyles}
              target="_self"
            >
              {children}
            </a>
          )
          : (
            <a
              href={href}
              className={linkStyles}
              target="_blank"
              rel="noopener noreferrer"
            >
              {children}
            </a>
          )}
      </>
    );
  }
  if (link?.internal?.type === ContentType.ContentfulSlug) {
    return (
      <Link
        to={link.slug}
        className={linkStyles}
      >
        {wrap ? children : linkTitle || link.title}
      </Link>
    );
  }
  if (link?.internal?.type === ContentType.ContentfulShow) {
    return (
      <Link
        to={`${link.node_locale === defaultLocale ? '' : `/${link.node_locale}`}${SlugPrefix.ChdTvShows}${link.slug}`}
        className={linkStyles}
      >
        {wrap ? children : linkTitle || link.title}
      </Link>
    );
  } if (link?.internal?.type === ContentType.ContentfulEvent) {
    return (
      <Link
        to={`${link.node_locale === defaultLocale ? '' : `/${link.node_locale}`}${SlugPrefix.ChdTvEvents}${link.slug}`}
        className={linkStyles}
      >
        {wrap ? children : linkTitle || link.title}
      </Link>
    );
  } if (link?.internal?.type === ContentType.ContentfulVideo) {
    return (
      <Link
        to={`${link.node_locale === defaultLocale ? '' : `/${link.node_locale}`}${SlugPrefix.ChdTvVideos}${link.slug}`}
        className={linkStyles}
      >
        {wrap ? children : linkTitle || link.title}
      </Link>
    );
  } if (link?.internal?.type === ContentType.ContentfulEpisode) {
    return (
      <Link
        to={`${link.node_locale === defaultLocale ? '' : `/${link.node_locale}`}${SlugPrefix.ChdTvShows}${link.show[0]?.slug}/${link.slug}`}
        className={linkStyles}
      >
        {wrap ? children : linkTitle || link.title}
      </Link>
    );
  } if (link?.internal?.type === ContentType.ContentfulEventVideo) {
    return (
      <Link
        to={`${link.node_locale === defaultLocale ? '' : `/${link.node_locale}`}${SlugPrefix.ChdTvEvents}${link.event[0]?.slug}/${link.slug}`}
        className={linkStyles}
      >
        {wrap ? children : linkTitle || link.title}
      </Link>
    );
  } if (link?.internal?.type === ContentType.ContentfulExternalLink) {
    return (
      <>
        {includesChdDomain(link.url)
          ? (
            <a
              href={link.url}
              className={linkStyles}
              target="_self"
            >
              {wrap ? children : linkTitle || link.title}
            </a>
          )
          : (
            <a
              href={link.url}
              className={linkStyles}
              target="_blank"
              rel="noopener noreferrer"
            >
              {wrap ? children : linkTitle || link.title}
            </a>
          )}
      </>
    );
  }
  return <></>;
}

export default LinkChd;
